import axios from "axios";
import { ApiEnum } from "../../constants/ApiEnum";

interface Data {
    data: {
        status: {
            message: {
                lat: number;
                lng: number;
            };
        };
    };
}

export const ApiGetCoordsByAddress = async (address: string): Promise<Data> => {
    return await axios
        .get(ApiEnum.GEOCODE + "?address=" + address)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
};
